import { useState } from "react";
import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";
import { DitlDoneButton } from "./DitlCardButtons";

const DitlCard = ({
  title,
  collapsedTitle = null,
  description = null,
  actionLabel = null,
  actionIcon: ActionIcon = null,
  onAction = null,
  onDone = null,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className={`tw-flex tw-flex-col tw-w-full tw-overflow-hidden tw-bg-white tw-border-[1px] tw-border-solid tw-border-gray-10 ${
        open ? "tw-rounded-[12px] tw-shadow-[0px_2px_8px_0px_rgba(213,213,213,0.5)]" : "tw-rounded-[16px]"
      }`}
    >
      <button
        type="button"
        className={`tw-flex tw-flex-col tw-gap-[8px] tw-w-full tw-bg-transparent tw-border-0 tw-text-left tw-cursor-pointer ${
          open
            ? "tw-px-[24px] tw-pt-[24px] tw-pb-[8px]"
            : "tw-justify-center tw-min-h-[52px] tw-px-[24px] tw-py-[8px]"
        }`}
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Typography variant={open ? "headline2" : "body-m"} component="span">
          {open ? title : collapsedTitle || title}
        </Typography>
        {open && description && (
          <Typography variant="body-m" component="span" className="!tw-text-gray-50">
            {description}
          </Typography>
        )}
      </button>
      {open && (
        <>
          <div className="tw-flex tw-flex-col tw-px-[24px] tw-pb-[16px]">
            {actionLabel && (
              <button
                type="button"
                className="tw-flex tw-items-center tw-gap-[4px] tw-self-start tw-h-[24px] tw-px-[8px] tw-bg-transparent tw-rounded-full tw-border-[1.5px] tw-border-solid tw-border-theme-primary-alternative tw-text-theme-primary-alternative tw-text-11d tw-font-bold tw-uppercase"
                onClick={onAction}
              >
                {ActionIcon && <ActionIcon className="tw-w-[8px] tw-h-[8px]" />}
                {actionLabel}
              </button>
            )}
          </div>
          <div className="tw-flex tw-justify-end tw-p-[16px] tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-t-[1px] tw-border-gray-10">
            <DitlDoneButton onClick={onDone} />
          </div>
        </>
      )}
    </div>
  );
};

DitlCard.propTypes = {
  title: PropTypes.string.isRequired,
  collapsedTitle: PropTypes.string,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  actionIcon: PropTypes.elementType,
  onAction: PropTypes.func,
  onDone: PropTypes.func,
  defaultOpen: PropTypes.bool,
};

export default DitlCard;
